module.exports = __webpack_public_path__ + "img/avatarka-2.1d4230aa.png";